export const EXPRESS_PAYMENT_TERMS = ['45', '60'];
export const INDIVIDUAL_ACCOUNT_TYPE = 1;
export const SWEDEN_COUNTRY = 'Sweden';;
